module.exports = __webpack_public_path__ + "static/media/circle-info.3446e596.svg";